"use client"
import {useState, useEffect} from "react"

const BasketRateFilterCard = ({basketTicketList, onFilterChange}) => {
  // ticketList 키 값으로 rateOptions 생성
  const rateOptions = Object.keys(basketTicketList).map(Number).sort((a, b) => a - b);
  const [selectedRates, setSelectedRates] = useState(rateOptions);

  useEffect(() => {
    setSelectedRates(rateOptions);
    onFilterChange(rateOptions);
  }, [basketTicketList])

  const handleRatesToggle = (rate) => {
    const newSelected = selectedRates.includes(rate)
      ? selectedRates.filter((o) => o !== rate)
      : [...selectedRates, rate]

    setSelectedRates(newSelected)
    onFilterChange(newSelected)
  }

  const handleSelectAll = () => {
    // 전체 선택/해제 핸들러

    // 비활성화된 옵션 제외
    const activeRates = rateOptions.filter(rate => basketTicketList[rate].length > 0);
    // 옵션이 선택되어 있으면 전체 해제, 아니면 전체 선택
    const allActiveSelected = activeRates.every(rate => selectedRates.includes(rate));

    const newSelected = allActiveSelected ? [] : activeRates;
    setSelectedRates(newSelected);
    onFilterChange(newSelected);
  }

  const isAllSelected = () => {
    // 전체 선택 여부 확인
    const activeRates = rateOptions.filter(rate => basketTicketList[rate].length > 0);
    return activeRates.length > 0 && activeRates.every(rate => selectedRates.includes(rate));
  }


  return (
    <div className="space-y-4 rounded-lg border border-gray-300 bg-card p-4 shadow-md bg-white">
      <h3 className="text-sm font-semibold text-foreground">배당 상세 필터</h3>

      <div className="flex flex-wrap gap-2">
        {/* 전체 버튼 */}
        <button
          onClick={handleSelectAll}
          className={`
            min-w-[56px] px-3 py-2 text-sm font-medium rounded-md shadow-md
            ${isAllSelected()
            ? "bg-blue-800 text-white"
            : "border border-slate-400 bg-slate-100 text-slate-900"}
          `}
        >
          전체
        </button>

        {rateOptions.map((rate) => {
          const isEmpty = basketTicketList[rate].length === 0;
          const isSelected = selectedRates.includes(rate);

          return (
            <button
              key={rate}
              disabled={isEmpty}
              onClick={() => handleRatesToggle(rate)}
              className={`
                min-w-[56px] px-3 py-2 text-sm font-medium rounded-md shadow-md
                ${isEmpty ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : isSelected ? "bg-blue-800 text-white"
                  : "border border-slate-400 bg-slate-100 text-slate-900"} 
              `}
            >
              {rate}
            </button>
          )
        })}
      </div>
    </div>
  )
}
export default BasketRateFilterCard;
